// removed by extract-text-webpack-plugin
module.exports = {"projectStatusIcon":"ProjectTable__projectStatusIcon___1msSk","tooltip":"ProjectTable__tooltip___OQb23","top":"ProjectTable__top___3zj3s"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectTable/ProjectTable.scss
// module id = 1190
// module chunks = 1